import { render, staticRenderFns } from "./AnalyticForm.vue?vue&type=template&id=2b6faf87&scoped=true&"
import script from "./AnalyticForm.vue?vue&type=script&lang=js&"
export * from "./AnalyticForm.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticForm.vue?vue&type=style&index=0&id=2b6faf87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6faf87",
  null
  
)

export default component.exports